import { render, staticRenderFns } from "./RepassePrestador.vue?vue&type=template&id=589cfc3a&"
import script from "./RepassePrestador.vue?vue&type=script&lang=js&"
export * from "./RepassePrestador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports